import "@/lib/zod-config";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { router } from "./router";
import "./index.css";
import "@/lib/studio-inspector";
import { addInstallTags, registerServiceWorker } from "@/lib/pwa";

addInstallTags();
registerServiceWorker();

const elem = document.getElementById("root");
if (!elem) throw new Error("Root element #root not found in index.html");
const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
